(function () {
  if (customElements.get('lookbook-carousel')) return;

  class LookbookCarousel extends HTMLElement {
    connectedCallback() {
      this._onResize = this.tryInit.bind(this);
      document.addEventListener('theme:resize:width', this._onResize);
      this.tryInit();
    }

    tryInit(attempt) {
      if (this.flickity) return;
      if (!window.theme || !window.theme.Flickity) {
        const tries = (attempt || 0) + 1;
        if (tries > 20) return;
        return void setTimeout(() => this.tryInit(tries), 100);
      }
      this.flickity = new window.theme.Flickity(this, {
        cellAlign: 'center',
        wrapAround: this.dataset.wrap === 'true',
        autoPlay: this.dataset.autoplay === 'true' ? parseInt(this.dataset.speed, 10) : false,
        pageDots: this.dataset.dots === 'true',
        prevNextButtons: this.dataset.arrows === 'true',
        pauseAutoPlayOnHover: true,
        adaptiveHeight: false,
        imagesLoaded: true,
      });

      const scope = this.closest('.overlapping-images__images') || this.parentElement;
      const currentEl = scope && scope.querySelector('[data-counter-current]');
      if (currentEl) {
        const pad = (n) => String(n + 1).padStart(2, '0');
        currentEl.textContent = pad(this.flickity.selectedIndex || 0);
        this.flickity.on('change', (i) => {
          currentEl.textContent = pad(i);
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('theme:resize:width', this._onResize);
      if (this.flickity) {
        this.flickity.destroy();
        this.flickity = null;
      }
    }
  }

  customElements.define('lookbook-carousel', LookbookCarousel);
})();
